import { render } from "./Head.vue?vue&type=template&id=3294c41c&scoped=true"
import script from "./Head.vue?vue&type=script&lang=ts"
export * from "./Head.vue?vue&type=script&lang=ts"

import "./Head.vue?vue&type=style&index=0&id=3294c41c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3294c41c"

export default script